import { useState, useContext, useEffect } from "react";
import axios from "axios";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import GLOBALVAR from "../constants";

const Register = () => {
    const { user, isLoading } = useContext(AuthContext); // Get logged-in user & loading state

    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        permissions: "staff", // Default to staff
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const { firstName, lastName, email, password, permissions } = formData;

    useEffect(() => {
        if (!isLoading && user?.permissions !== "admin") {
            navigate("/"); // Redirect non-admin users away
        }
    }, [user, isLoading, navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token"); // Get admin token
            const { data } = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/users/register`,
                { firstName, lastName, email, password, permissions },
                { headers: { Authorization: `Bearer ${token}` } } // Added Bearer prefix
            );
            console.log("API Response:", data); // Log the response data
            setSuccess("User registered successfully!");
            setFormData({ firstName: "", lastName: "", email: "", password: "", permissions: "staff" });
            setError(null);
            setTimeout(() => navigate("/"), 2000);
        } catch (err) {
            setError(err.response?.data?.message || "Registration failed");
            setSuccess(null);
        }
    };

    if (isLoading) return null; // Prevent access check before loading is done

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="card shadow-lg p-4" style={{ width: '25rem' }}>
                <h3 className="text-center mb-4">Register New User</h3>

                {/* Error and Success Messages */}
                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    {/* First Name */}
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label">First Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="firstName"
                            name="firstName"
                            placeholder="Enter first name"
                            value={firstName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Last Name */}
                    <div className="mb-3">
                        <label htmlFor="lastName" className="form-label">Last Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="lastName"
                            name="lastName"
                            placeholder="Enter last name"
                            value={lastName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Permissions */}
                    <div className="mb-3">
                        <label htmlFor="permissions" className="form-label">Role</label>
                        <select
                            className="form-select"
                            id="permissions"
                            name="permissions"
                            value={permissions}
                            onChange={handleChange}
                        >
                            <option value="staff">Staff</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary w-100">Register</button>
                </form>
            </div>
        </div>
    );
};

export default Register;
